module.exports = __webpack_public_path__ + "static/img/cocina_20.f72658a3.png";